import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import InformationModal from '../../common/InformationModal'

import * as Strings from './strings'
import * as configActions from '../../actions/Config'
import * as informationActions from '../../actions/InformationItems'
import * as Constants from '../../../helpers/Constants'

class EditInformationItemModal extends Component {
  state = {
    titleInput: '',
    errorTitle: '',
    titleEnglishInput: '',
    informationInput: '',
    errorInformation: '',
    informationEnglishInput: '',
    errorMessage: '',
    type: Constants.PHONE
  }

  componentWillReceiveProps(nextProps) {
    const { config, informationItems } = this.props

    if (
      nextProps.config.editInformationItemModal.show &&
      !config.editInformationItemModal.show
    ) {
      this.setState({
        titleInput: nextProps.informationItems.selected.title,
        errorTitle: '',
        titleEnglishInput: nextProps.informationItems.selected.titleEN,
        informationInput: nextProps.informationItems.selected.information,
        errorInformation: '',
        informationEnglishInput:
          nextProps.informationItems.selected.informationEN,
        errorMessage: '',
        type: nextProps.informationItems.selected.type
      })
    }

    if (
      !nextProps.informationItems.isUpdating &&
      nextProps.informationItems.errorUpdating === null &&
      informationItems.isUpdating
    ) {
      this.props.hideEditInformationItemModal()
      this.props.showSnackbar(Strings.default.INFORMATION_UPDATED)
    } else if (
      !nextProps.informationItems.isUpdating &&
      nextProps.informationItems.errorUpdating !== null &&
      informationItems.isUpdating
    ) {
      this.setState({ errorMessage: Strings.default.INTERNAL_ERROR })
    }
  }

  updateInformation() {
    const { data, user, informationItems } = this.props
    const {
      titleInput,
      titleEnglishInput,
      informationInput,
      informationEnglishInput,
      type
    } = this.state

    this.setState({ errorMessage: '' })

    if (titleInput === '') {
      this.setState({ errorTitle: Strings.default.MANDATORY_FIELD })
    }

    if (informationInput === '') {
      this.setState({ errorInformation: Strings.default.MANDATORY_FIELD })
    }

    if (titleInput !== '' && informationInput !== '') {
      const postData = {
        title: titleInput,
        titleEN: titleEnglishInput === '' ? titleInput : titleEnglishInput,
        information: informationInput,
        informationEN:
          informationEnglishInput === '' || type !== Constants.TEXT
            ? informationInput
            : informationEnglishInput,
        type
      }

      this.props.tryUpdateInformationItem(
        user.token,
        data.community.id,
        informationItems.selected.id,
        postData
      )
    }
  }

  render() {
    const { config, informationItems } = this.props
    const {
      titleInput,
      errorTitle,
      titleEnglishInput,
      informationInput,
      errorInformation,
      informationEnglishInput,
      errorMessage,
      type
    } = this.state

    return (
      <InformationModal
        show={config.editInformationItemModal.show}
        hide={() => this.props.hideEditInformationItemModal()}
        titleInput={titleInput}
        errorTitle={errorTitle}
        onChangeTitle={text =>
          this.setState({
            titleInput: text,
            errorTitle: '',
            errorMessage: ''
          })
        }
        titleEnglishInput={titleEnglishInput}
        onChangeTitleEnglish={text =>
          this.setState({
            titleEnglishInput: text,
            errorMessage: ''
          })
        }
        informationInput={informationInput}
        errorInformation={errorInformation}
        onChangeInformation={text =>
          this.setState({
            informationInput: text,
            errorInformation: '',
            errorMessage: ''
          })
        }
        informationEnglishInput={informationEnglishInput}
        onChangeInformationEnglish={text =>
          this.setState({
            informationEnglishInput: text,
            errorMessage: ''
          })
        }
        header={Strings.default.EDIT_INFORMATION}
        information={Strings.default.EDIT_INFORMATION_INFO}
        onDone={() => this.updateInformation()}
        loading={informationItems.isUpdating}
        type={type}
        onChangeType={newType => this.setState({ type: newType })}
        errorMessage={errorMessage}
      />
    )
  }
}

function mapStateToProps({ config, data, user, informationItems }) {
  return { config, data, user, informationItems }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { ...configActions, ...informationActions },
    dispatch
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditInformationItemModal)



// WEBPACK FOOTER //
// ./src/components/containers/EditInformationItemModal/index.js